import React from 'react';

import {listPageClassName} from 'shared/ui/ListPage/ListPage';

import {MainLayout} from 'widgets/layout';

import {PortMonitors} from 'features/port';

const PortMonitorsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <PortMonitors />
        </MainLayout>
    );
};

export default PortMonitorsPage;
